const API = {
  POST_SIGN_IN: {
    path: '/auth/sign-in',
    method: 'POST',
  },
  POST_SIGN_OUT: {
    path: '/auth/logout',
    method: 'POST',
  },
  POST_RESET_PASSWORD: {
    path: '/auth/change-password',
    method: 'POST',
  },
  POST_RESET_TEMP_PASSWORD: {
    path: '/auth/sign-in',
    method: 'POST',
  },
  GET_USER_DETAILS: {
    path: '/auth/me',
    method: 'GET',
  },
  POST_FORGOT_PASSWORD: {
    path: '/auth/forgot-password',
    method: 'POST',
  },
  POST_REFRESH_TOKEN: {
    path: '/auth/refresh-token',
    method: 'POST',
  },
  GENERATE_CONNECT_URL: {
    path: '/stripe/connect/generate-url',
    method: 'POST',
  },
  GET_STRIPE_DASHBOARD_URL: {
    path: '/stripe/connect/dashboard-url',
    method: 'POST',
  },
  GET_CATEGORIES: {
    path: '/categories',
    method: 'GET',
  },
};
export default API;
